"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccountType = void 0;
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["CurrentAccount"] = "CurrentAccount";
    BankAccountType["SavingsAccount"] = "SavingsAccount";
    BankAccountType["CashAccount"] = "CashAccount";
    BankAccountType["CreditCard"] = "CreditCard";
    BankAccountType["TrustAccount"] = "TrustAccount";
    BankAccountType["Other"] = "Other";
})(BankAccountType = exports.BankAccountType || (exports.BankAccountType = {}));
